<template>
  <div>
    <!-- Snackbar for Notifications -->
    <v-snackbar v-model="snackbar" :color="color" :timeout="4000" top>
      {{ snackbar_msg }}
      <v-btn text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <div> <v-toolbar class="custom-toolbar mb-4" flat dense>
        <v-toolbar-title>Current Subjects</v-toolbar-title>
      </v-toolbar></div>
    <div> <v-row class="justify-center">
        <v-col sm="4" md="3" cols="12">
          <div class="pl-1 pb-2" style="font-size: 14px;"><b>Academic Year</b></div>
          <v-autocomplete rounded dense required v-model="ay" :items="ay_list" item-text="ay"
            @change="getCurrentSubjectoOnChange(ay)" return-object outlined persistent-hint
            hint="Please select academic year"></v-autocomplete>
        </v-col>
      </v-row>
    </div>
    <div class="cards">      
      <!-- Grid of Cards -->
      <div class="card" v-for="(subject, index) in subject_list" :key="index">
        <article>
          <h2>{{ subject.course_name }}</h2>
          <div class="pic">
            <!-- <v-icon color="primary" large>mdi-book-open-variant</v-icon> -->
            {{ subject.course_rule }}
          </div>
          <!-- <v-chip class="mt-1" color="primary" text-color="white" small>
         {{ subject.course_rule }}
        </v-chip> -->
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    learner: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      snackbar: false,
      snackbar_msg: "",
      color: "error",
      subject_list: [],
      ay_list: [],
      ay: null,
    };
  },
  watch: {
    learner(newVal) {
      if (newVal) this.getCurrentSubject();
    },
  },
  methods: {
    getCurrentSubject() {
      axios
        .post("/parent/getCurrentSubject", { learner: this.learner })
        .then((res) => {
          if (res.data.flag === "YES") {
            this.subject_list = res.data.subject_list;
            this.subject_list = res.data.subject_list.filter(
              subject => subject.course_name !== "NA : NA"
            );

            this.ay_list = res.data.ay_list;
            this.ay = res.data.ay_list[0];
          } else {
            this.showSnackbar("error", res.data.snackbar || "Something went wrong...");
          }
        })
        .catch(() => {
          this.showSnackbar("error", "Server error while fetching subject data.");
        });
    },
    getCurrentSubjectoOnChange(ay) {
      this.subject_list = []
      const data = {
        learner: this.learner,
        ay: ay.id
      }
      axios
        .post("/parent/getCurrentSubject", data)
        .then((res) => {
          if (res.data.flag === "YES") {
            this.subject_list = res.data.subject_list;
            this.subject_list = res.data.subject_list.filter(
              subject => subject.course_name !== "NA : NA"
            );

          } else {
            this.showSnackbar("error", res.data.snackbar || "Something went wrong...");
          }
        })
        .catch(() => {
          this.showSnackbar("error", "Server error while fetching subject data.");
        });
    },
    showSnackbar(color, msg) {
      this.color = color;
      this.snackbar_msg = msg;
      this.snackbar = true;
    },
  },
  mounted() {
    this.getCurrentSubject();
  },
};
</script>

<style scoped>
.cards {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  padding: 10px;
}

.card {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0px 20px 30px -10px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 200px;
  min-width: 120px;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  position: relative;
  transition: all 0.4s ease;
  margin: 0 auto;
}

.custom-toolbar {
  background: #4a148c;
}

.custom-toolbar {
  background: linear-gradient(to right, #a8edea, #e4d0ff);
  background: linear-gradient(to right, #a8edea, #e4d0ff);
}

.card::before {
  height: 110px;
  width: calc(100% + 100px);
  content: "";
  position: absolute;
  background-image: radial-gradient(circle, rgba(254, 235, 243, 1) 0%, rgba(148, 187, 233, 1) 100%);
  border-radius: 4px 4px 100% 100%;
  transition: all 0.4s ease-out;
  top: 0;
  left: -50px;
}

.card article {
  z-index: 1;
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
}

.card article h2 {
  color: #000000;
  margin: 0;
  padding: 20px 20px 0px 20px;
  font-weight: 500;
  height: 69px;
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.card article .pic {
  width: 70px;
  height: 70px;
  overflow: hidden;
  border-radius: 100%;
  margin: 20px 0 10px;
  background: #fff;
  transition: all 0.6s ease;
  border: 1px solid #777;
  display: flex;
  justify-content: center;
  align-items: center;
}

.card:hover {
  transform: translateY(-10px);
  box-shadow: 0px 5px 10px -5px rgba(0, 0, 0, 0.3);
}

.card:hover::before {
  height: 100%;
  border-radius: 4px;
}

.card:hover .pic {
  box-shadow: 0px 0px 0px 8px #5965c0;
}

@media (max-width: 1264px) {
  .cards .card {
    max-width: 180px;
  }
}

@media (max-width: 960px) {
  .cards .card {
    max-width: 160px;
  }
}

@media (max-width: 600px) {
  .cards .card {
    max-width: 100%;
    min-width: 100px;
  }
}
</style>
